// extracted by mini-css-extract-plugin
export default {"wrapper":"table-search_wrapper__H56Wr","wrapper2":"table-search_wrapper2__zKfdY"};